import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const Error = ({
  error
}) => /*#__PURE__*/React.createElement("div", {
  className: "d-flex flex-column align-items-center justify-content-center mydpd-commodity-finder-error"
}, /*#__PURE__*/React.createElement("img", {
  alt: "face",
  src: error.icon
}), /*#__PURE__*/React.createElement("div", {
  className: "mydpd-commodity-finder-error-header"
}, error.header), /*#__PURE__*/React.createElement("div", {
  className: "mydpd-commodity-finder-error-message"
}, error.message));

Error.propTypes = {
  error: PropTypes.objectOf({
    header: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.string
  })
};
export default Error;